import axios from 'axios';
import { API_BASE_URL } from '@/config';

export class ManagedAccountsApi {
  static list = (type) =>
    axios.get(`${API_BASE_URL}/managed-accounts`, {
      params: type ? { type } : undefined,
      skipToast: true,
    });

  static get = (id) =>
    axios.get(`${API_BASE_URL}/managed-accounts/${id}`, { skipToast: true });

  static create = (data) =>
    axios.post(`${API_BASE_URL}/managed-accounts`, data, { skipToast: true });

  static getPaymentsManager = (id) =>
    axios.get(`${API_BASE_URL}/managed-accounts/${id}/payments-manager`, {
      skipToast: true,
    });

  static updatePaymentsManager = (id, data) =>
    axios.put(`${API_BASE_URL}/managed-accounts/${id}/payments-manager`, data, {
      skipToast: true,
    });

  static testPaymentsManagerConnection = (id) =>
    axios.post(
      `${API_BASE_URL}/managed-accounts/${id}/payments-manager/test-connection`,
      undefined,
      { skipToast: true },
    );

  static getPositivePay = (id) =>
    axios.get(`${API_BASE_URL}/managed-accounts/${id}/positive-pay`, {
      skipToast: true,
    });

  static updatePositivePay = (id, data) =>
    axios.put(`${API_BASE_URL}/managed-accounts/${id}/positive-pay`, data, {
      skipToast: true,
    });

  static testPositivePayConnection = (id) =>
    axios.post(
      `${API_BASE_URL}/managed-accounts/${id}/positive-pay/test-connection`,
      undefined,
      { skipToast: true },
    );
}
